<div [class.boxed]="isBoxed$ | async" [class.horizontal-layout]="!(isLayoutVertical$ | async)"
  [class.is-mobile]="!(isDesktop$ | async)" [class.vertical-layout]="isLayoutVertical$ | async"
  [class.has-fixed-footer]="(isFooterFixed$ | async) && isFooterVisible$ | async"
  [class.has-footer]="isFooterVisible$ | async" [class.scroll-disabled]="scrollDisabled$ | async"
  [class.toolbar-fixed]="isToolbarFixed$ | async" [class.sidenav-collapsed]="sidenavCollapsed$ | async"
  [class.content-container]="containerEnabled$ | async" [class.with-search]="searchOpen$ | async"
  class="page-container">

  <vex-progress-bar></vex-progress-bar>

  <!-- Warning Banner for temporary password -->
  <div *ngIf="authenticationService.auth.resetPasswordRequired"
    class="bg-amber-50 border-l-4 border-amber-500 p-4 sticky top-0 z-50 flex justify-between items-center">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 mr-3" svgIcon="mat:warning"></mat-icon>
      <span class="text-amber-800">Please reset your password as you are using a temporary password.</span>
    </div>
    <div class="flex items-center">
      <a mat-button color="primary" class="font-medium" [routerLink]="['/account-settings/security']">Reset Password</a>
      <!-- <button mat-icon-button (click)="dismissBanner()" matTooltip="Dismiss for now">
        <mat-icon svgIcon="mat:close"></mat-icon>
      </button> -->
    </div>
  </div>

  <vex-search></vex-search>

  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav [disableClose]="isDesktop$ | async" [fixedInViewport]="!(isDesktop$ | async)"
      [mode]="!(isDesktop$ | async) || (isLayoutVertical$ | async) ? 'over' : 'side'"
      [opened]="(isDesktop$ | async) && !(isLayoutVertical$ | async)" class="sidenav">
      <ng-container *ngTemplateOutlet="sidenavRef"></ng-container>
    </mat-sidenav>

    <mat-sidenav #quickpanel [fixedInViewport]="!(isDesktop$ | async)" class="quickpanel" mode="over" position="end">
      <ng-container *ngTemplateOutlet="quickpanelRef"></ng-container>
    </mat-sidenav>

    <mat-sidenav-content class="sidenav-content">
      <ng-container *ngTemplateOutlet="toolbarRef"></ng-container>

      <main class="content">
        <router-outlet></router-outlet>
      </main>

      <ng-container *ngTemplateOutlet="footerRef"></ng-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>